import React from 'react';
import HeroSlider from '../components/HeroSlider';
import AboutSection from '../components/AboutSection';
import StatsSection from '../components/StatsSection';
import ServicesSection from '../components/ServicesSection';
import QuoteSection from '../components/QuoteSection';
import VisionTabs from '../components/VisionTabs';
import WaysToTransform from '../components/WaysToTransform';
import VideoSection from '../components/VideoSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import PartnersSection from '../components/PartnersSection';

const Home = () => (
  <main>
    <HeroSlider />
    <AboutSection />
    <StatsSection />
    <ServicesSection />
    <QuoteSection />
    <VisionTabs />
    <WaysToTransform />
    <VideoSection />
    <TestimonialsSection />
    <CTASection />
    <PartnersSection />
  </main>
);

export default Home;
